import { combineReducers } from "redux";
import telas from "./slices/telas.slice";
import menus from "./slices/menus.slice";
import gruposDeAcesso from "./slices/gruposDeAcesso.slice";
import configAcessos from "./slices/configAcessos.slice";

const reducer = combineReducers({
  telas,
  menus,
  gruposDeAcesso,
  configAcessos,
});

export default reducer;
